const UsuarioPerfilEnum = Object.freeze({
  Nenhum: 0,
  //Admin: 1,
  Caixa: 2,
  Pedidos: 4,
  Garcom: 5,
});

export default UsuarioPerfilEnum;


export const UsuarioPerfilLabel = Object.freeze({
  0: 'Nenhum',
  //1: 'Administrador',
  2: 'Caixa',
  4: 'Pedidos',
  5: 'Garçom',
});
